module.exports = [
    'contact_me',
    'portfolio',
    'pro_spotlights',
    'testimonials',
    'video',
]
